import { useState } from 'react';
import VersionHistoryDrawer from './VersionHistoryDrawer';
import { PiClockCounterClockwiseFill } from "react-icons/pi";



const VersionHistory = ({ id, handleEditSheet }) => {
    const [showDrawer, setShowDrawer] = useState(false);

    return (
        <>
            <div
                className="relative group flex items-center sm:gap-2 px-1 sm:px-3 py-1 cursor-pointer transition-all duration-200"
                onClick={() => setShowDrawer(true)}
                onMouseEnter={(e) => {
                    const tooltip = e.currentTarget.querySelector('.version-tooltip');
                    if (tooltip) tooltip.style.opacity = '1';
                }}
                onMouseLeave={(e) => {
                    const tooltip = e.currentTarget.querySelector('.version-tooltip');
                    if (tooltip) tooltip.style.opacity = '0';
                }}
            >
                <PiClockCounterClockwiseFill size={32}  />


                <div
                    className="version-tooltip z-[10000] absolute top-full left-1/2 mb-2 px-3 py-1.5 bg-gray-900 text-white text-xs rounded-md whitespace-nowrap pointer-events-none transition-opacity duration-200"
                    style={{
                        transform: 'translateX(-50%)',
                        opacity: 0,
                    }}
                >
                    Versions
                    <div
                        className="absolute bottom-full left-1/2 border-4 border-transparent border-b-gray-900"
                        style={{ transform: 'translateX(-50%)', marginBottom: '-8px' }}
                    ></div>
                </div>
            </div>

            <VersionHistoryDrawer
                show={showDrawer}
                onHide={() => setShowDrawer(false)}
                sheetId={id}
                handleEditSheet={handleEditSheet}
            />
        </>
    );
};

export default VersionHistory;